import SavingsCard from './SavingsCard'

export default SavingsCard